export default __webpack_public_path__ + "static/media/Koffi_Wogomebou.6c6db9b4.png";